import { UserWeddingRole } from "./wedding";

export type Dashboard = {
  accountName: string;
  imageInfoText: string;
  coupleImage: string;
  brideFirstName: string;
  brideLastName: string;
  groomFirstName: string;
  groomLastName: string;
  creatorRole: UserWeddingRole;
  date: string;
  hasNotOnboarded: boolean;
  hasMultiAccounts: boolean;
  lastUpdatedUbxdidAt: Date;
};

export const DefaultDashboard: Dashboard = {
  accountName: "",
  imageInfoText: "",
  coupleImage: "",
  brideFirstName: "",
  brideLastName: "",
  groomFirstName: "",
  groomLastName: "",
  creatorRole: "" as UserWeddingRole,
  date: "",
  hasNotOnboarded: false,
  hasMultiAccounts: false,
  lastUpdatedUbxdidAt: "" as any,
};
